import { FIND_INDICADORES } from "@/apollo/queries";
import { exQue } from "@/utils/gql";

const normalizeText = (value = "") =>
  value
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

const parseChileIndicadores = (items = []) => {
  const chile = items.find((item) => normalizeText(item?.titulo) === "chile");
  if (!chile || !Array.isArray(chile.opciones)) {
    return { dolar: 0, euro: 0, uf: 0 };
  }

  const result = { dolar: 0, euro: 0, uf: 0 };

  chile.opciones.forEach((opcion) => {
    const nombre = normalizeText(opcion?.nombre_indicador);
    const valor = Number(opcion?.valor) || 0;

    if (nombre === "dolar") {
      result.dolar = valor;
      return;
    }

    if (nombre === "euro") {
      result.euro = valor;
      return;
    }

    if (nombre === "uf") {
      result.uf = valor;
    }
    /* Otros indicadores que podrían ser útiles en el futuro:
      UTM
      IVP
      IPC
      Imacec
      TPM
      Libra
      Bitcoin
    */
  });

  return result;
};

export default {
  namespaced: true,
  state: {
    // Selector de divisa del Dashboard de EPP: el código, para que quepa en la
    // barra de filtros
    indicadoresOpts: [
      {
        name: "CLP",
        id: 'clp'
      },
      {
        name: "USD",
        id: 'dolar'
      },
      {
        name: "EUR",
        id: 'euro'
      },
      {
        name: "UF",
        id: 'uf'
      }
    ],
    indicadores: {},
  },
  mutations: {
    setIndicadores(state, indicadores) {
      state.indicadores = indicadores;
    }
  },
  getters: {
    transformVal: (state) => (valor, divisa) => {
      const numericValor = Number(valor) || 0;

      if (divisa === 'clp') {
        return numericValor;
      }

      const rate = Number(state.indicadores[divisa]);
      if (!rate) {
        return numericValor;
      }

      return Number((numericValor / rate).toFixed(2));
    }
  },
  actions: {
    fetchIndicadores({ state, commit }) {
      // El caché es por día de Chile: en UTC el día cambia a las 21:00 / 20:00
      const today = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Santiago' }).format(new Date());
      let indicadoresLocal = null;
      try {
        indicadoresLocal = JSON.parse(localStorage.getItem('indicadores'));
      } catch (error) {
        indicadoresLocal = null;
      }

      if (indicadoresLocal && indicadoresLocal.date === today) {
        commit('setIndicadores', indicadoresLocal.data)
        return Promise.resolve(indicadoresLocal.data);
      }

      return exQue(FIND_INDICADORES).then((data) => {
        const newData = parseChileIndicadores(data);
        // Sin ningún valor no se guarda, para volver a pedirlos en la próxima carga
        if (newData.dolar || newData.euro || newData.uf) {
          localStorage.setItem('indicadores', JSON.stringify({
            date: today,
            data: newData
          }));
        }
        commit('setIndicadores', newData)
        return newData;
      }).catch(() => {
        const fallback = {
          dolar: Number(state.indicadores?.dolar) || 0,
          euro: Number(state.indicadores?.euro) || 0,
          uf: Number(state.indicadores?.uf) || 0,
        };
        commit('setIndicadores', fallback);
        return fallback;
      })
    }
  }
}